








const samplefocusDefaults = JSON.parse('{"credits_earned_per_upload":4,"category_of_the_month_multiplier":2,"category_of_the_month":"brass","credits_earned_per_referral":10,"credits_given_per_period":3,"pause_duration_in_months":2,"registration_bonus":5,"sample_rejection_retention_period_in_days":7,"sign_up_offer_time_limit_in_minutes":30}')
const MINIMUM_TAG_LIST_LENGTH = parseInt('4')
const MINIMUM_COLLECTION_SIZE = parseInt('4')
const createCollectionApiUrl = ('http://localhost:3000/api/collections')
const createSampleEventApiUrl = ('http://localhost:3000/api/sample_events')
const needsMoreInfoReasons = JSON.parse('{"category":"Incorrect category.","naming":"Non-descriptive name: Choose a name that lets a friend know what to expect before listening. Avoid numbering samples and generic names.","tags":"Too few or incorrect tags: Add enough tags so that a friend knows what to expect before listening."}')
const rejectionReasons = JSON.parse('{"copyright":"Sample contains copyrighted material","corrupted":"Corrupted file, try re-uploading and ensuring correct file format","duplicate":"Duplicate sample has already been uploaded","low_quality":"Low quality audio or sample","quiet":"Sample is too quiet","remove_silence":"Please remove the silence in the audio sample","too_short":"Sample is too short in duration"}')
const categoryColors = JSON.parse('{"bass":"#ef5350","brass":"#9fa8da","bowed string":"#ab47bc","field recordings":"#42a5f5","guitar":"#29b6f6","keys":"#26c6da","pads \u0026 atmospheres":"#26a69a","drums":"#9c27b0","plucked string":"#64ffda","sound effects":"#9ccc65","synthesizers":"#0277bd","vocals":"#5c6bc0","woodwinds":"#00e5ff"}')
const editUploadedV2Url = '/samples/edit_uploaded_v2'
const reportReasons = JSON.parse('{"abusive":"Abusive or hateful content","copyright":"Violates copyright"}')

export {
    MINIMUM_COLLECTION_SIZE,
    MINIMUM_TAG_LIST_LENGTH,
    samplefocusDefaults,
    createCollectionApiUrl,
    createSampleEventApiUrl,
    needsMoreInfoReasons,
    rejectionReasons,
    categoryColors,
    reportReasons,
    editUploadedV2Url
}
